'use client'

// Controls the global UI-overlay visibility flag in gameStore.
// Default: visible on every device. Tab toggles (desktop). On mobile/touch
// there's no easy keyboard, but the listener is harmless to leave bound.
//
// Renders nothing — it's a side-effect only component.

import { useEffect } from 'react'
import useGameStore from '../../stores/gameStore'

export function UIOverlayController() {
  const setUiVisible = useGameStore((s) => s.setUiVisible)
  const toggleUiVisible = useGameStore((s) => s.toggleUiVisible)
  const uiVisible = useGameStore((s) => s.uiVisible)

  // Initial visibility — runs once on mount. Visible by default everywhere;
  // user presses Tab to hide for cinematic view.
  useEffect(() => {
    if (uiVisible !== null) return
    setUiVisible(true)
  }, [uiVisible, setUiVisible])

  // Tab key toggles overlay (desktop only). Prevent default so focus doesn't
  // jump through DOM. Skip if user is typing in an input or textarea.
  useEffect(() => {
    function onKeyDown(e) {
      if (e.key !== 'Tab') return
      const t = e.target
      const tag = t?.tagName
      if (tag === 'INPUT' || tag === 'TEXTAREA' || t?.isContentEditable) return
      e.preventDefault()
      toggleUiVisible()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [toggleUiVisible])

  return null
}
